export function formatViews(n: number): string {
  if (n >= 10000) {
    const w = (n / 10000).toFixed(1).replace(/\.0$/, "");
    return `${w} 万阅读`;
  }
  return `${n} 阅读`;
}

export function formatCount(n: string): string {
  return n;
}